// src/data/suraData.js

export const suraData = [
  {
    id: 0,
    name: "Subhanaka Du'a",
    arabic:
      'سُبْحَانَكَ اللَّهُمَّ وَبِحَمْدِكَ وَتَبَارَكَ اسْمُكَ وَتَعَالَى جَدُّكَ وَلَا إِلَهَ غَيْرُكَ',
    turkish: "Subhanaka Du'a",
    videoUrl: 'https://www.youtube.com/watch?v=nfRplJ7QJIk',
  },
  {
    id: 1,
    name: 'Surah Al-Fatiha',
    arabic: 'بِسْمِ ٱللَّهِ ٱلرَّحْمَـٰنِ ٱلرَّحِيمِ',
    turkish: 'Opening Surah',
    videoUrl: 'https://www.youtube.com/watch?v=aR7yB_x9_G4',
  },
  {
    id: 2,
    name: "At-Tahiyyat Du'a",
    arabic: 'اَلتَّحِيَّاتُ لِلَّهِ وَالصَّلَوَاتُ وَالطَّيِّبَاتُ',
    turkish: "Tahiyyat Du'a",
    videoUrl: 'https://www.youtube.com/watch?v=kiPS87Br7Xo',
  },
  {
    id: 3,
    name: 'Adhan (Call to Prayer)',
    arabic: 'اَللّٰهُ اَكْبَرُ اَللّٰهُ اَكْبَرُ',
    turkish: 'Adhan (Call to Prayer)',
    videoUrl: 'https://www.youtube.com/watch?v=QT4j25EG54o',
  },
  {
    id: 4,
    name: 'Iqamah',
    arabic: 'اَللّٰهُ اَكْبَرُ اَللّٰهُ اَكْبَرُ (قَدْ قَامَتِ الصَّلَاةُ)',
    turkish: 'Iqamah (Start of Prayer)',
    videoUrl: 'https://www.youtube.com/watch?v=i1KnO79SkWQ',
  },
  {
    id: 5,
    name: 'Surah Al-Kawthar',
    arabic: 'إِنَّا أَعْطَيْنَاكَ الْكَوْثَرَ',
    turkish: 'Surah Al-Kawthar',
    videoUrl: 'https://www.youtube.com/watch?v=HnEJXREZUKE',
  },
  {
    id: 6,
    name: 'Surah Al-Kafirun',
    arabic: 'قُلْ يَا أَيُّهَا الْكَافِرُونَ',
    turkish: 'Surah Al-Kafirun',
    videoUrl: 'https://www.youtube.com/watch?v=3jE8WdZveRA',
  },
  {
    id: 7,
    name: 'Surah Al-Ikhlas',
    arabic: 'قُلْ هُوَ اللَّهُ أَحَدٌ',
    turkish: 'Surah Al-Ikhlas',
    videoUrl: 'https://www.youtube.com/watch?v=QrAMXvZ0TdM',
  },
  {
    id: 8,
    name: 'Surah Al-Falaq',
    arabic: 'قُلْ أَعُوذُ بِرَبِّ الْفَلَقِ',
    turkish: 'Surah Al-Falaq',
    videoUrl: 'https://www.youtube.com/watch?v=QrAMXvZ0TdM',
  },
  {
    id: 9,
    name: 'Surah An-Nas',
    arabic: 'قُلْ أَعُوذُ بِرَبِّ ٱلنَّاسِ',
    turkish: 'Surah An-Nas',
    videoUrl: 'https://www.youtube.com/watch?v=I2dVQHU3b54',
  },
];
